import { useEffect, useState } from 'react'

import api from '@functions/api'

export type CanvaAutofillField = {
  group: string,
  key: string,
  label: string,
}

function useCanvaAutofillFields() {
  const [fields, setFields] = useState<CanvaAutofillField[]>([])
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])

  useEffect(() => {
    let active = true

    setLoading(true)

    api('/canva/autofill_fields')
      .then(({ data }: { data: CanvaAutofillField[] }) => {
        if (!active) return

        setFields(data)
        setLoading(false)
      })
      .catch(() => {
        if (!active) return

        setErrors(['Unable to load Canva autofill fields'])
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [])

  return {
    errors,
    fields,
    loading,
  }
}

export default useCanvaAutofillFields
